import { connect } from 'react-redux';
import { actions } from '../../../../redux/modules/registro_sanitario/nuevoRegistroSanitario';
import Registros from './NuevoRegistroSanitario';


const ms2p = (state) => {
  return {
    ...state.rs_nuevo_registro_sanitario,
  };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(Registros);
